export default __webpack_public_path__ + "static/media/citrus.1af6f970.jpeg";